import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useEffect, useState } from 'react';
import { useSite } from '../../context/site';

function ChildrenActiveOverAge12Report() {
    const { GetChildrenActiveOverAge12Report } = useSite();

    const [loaded, setLoaded] = useState(false);
    const [children, setChildren] = useState([]);

    // Get children
    useEffect(() => {
        if (!loaded) {
            GetChildrenActiveOverAge12Report({}, (res) => {
                setChildren(res.data.children);
                setLoaded(true);
            });
        }
    }, [loaded, GetChildrenActiveOverAge12Report]);

    return (
        <div className="mt-2">
            <DataTable
                value={children}
                emptyMessage="No children found"
                showGridlines
                stripedRows
                removableSort
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 25, 50]}
                loading={!loaded}
                rowClassName={(child) => (child.active ? 'g' : 'r')}
            >
                <Column field="nameFirst" header="First Name" sortable></Column>
                <Column field="nameLast" header="Last Name" sortable></Column>
                <Column field="age" header="Age" sortable></Column>
                <Column field="parent.nameFull" header="Parent" sortable></Column>
            </DataTable>
        </div>
    );
}

export default ChildrenActiveOverAge12Report;
